import React from 'react';
import { Dialog } from '@reach/dialog';
import '@reach/dialog/styles.css';

import Button from './Button';
import CloseSVG from '../svg/icons/close.svg';

const Modal = ({ children, closeHandler, titleText, ...props }) => (
  <Dialog
    aria-label={titleText}
    onDismiss={closeHandler}
    className="align-bottom bg-white rounded-lg mx-4 px-4 pt-5 pb-4 text-left shadow-xl transform transition-all my-8 sm:align-middle w-full md:max-w-lg"
    {...props}
  >
    <div className="block absolute top-0 right-0 pt-4 pr-4">
      <Button
        id="close-button"
        appearance="minimal"
        colour="dark"
        size="small"
        onClick={closeHandler}
        className="hover:text-cornflower"
        aria-label="Close"
      >
        <CloseSVG className="h-4" />
      </Button>
    </div>
    <div>{children}</div>
  </Dialog>
);

export default Modal;
